import React, { Component } from "react";
import env from "../../env";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import moment from "moment";
import debounce from "lodash.debounce";
import Grid from "@material-ui/core/Grid/Grid";
import Person from "@material-ui/icons/Person";
import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";
import Ticket from "@material-ui/icons/ConfirmationNumber";
import Lock from "@material-ui/icons/Lock";
import LocationCity from "@material-ui/icons/LocationCity";
import Group from "@material-ui/icons/Group";
import Typography from "@material-ui/core/Typography";
import { userAction } from "../../actions/user.action";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import ErrorMessage from "../../components/UI/ErrorMessage";
import usStates from "../../utilities/us-states";
import CenteredContent from "../../components/UI/CenteredContent";
import PhoneNumberField from "../../components/Forms/PhoneNumberField";
import DatePicker from "../../components/Forms/DatePicker";
import qs from "qs";

const styles = (theme) => ({
  signupForm: {
    [theme.breakpoints.down("md")]: {
      flexDirection: "row !important",
    },
  },
  form: {
    width: "100%", // Fix IE11 issue.
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
    },
    "& label": {
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
    "& input, & select": {
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
    "& svg": {
      fontSize: 17,
      marginBottom: 6,
    },
    "& .DayPickerInput": {
      width: "100%",
    },
    "& .LoginBirthdatePicker": {
      width: "100%",
    },
  },
  cta: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  ctaSignup: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  loginHeader: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "#FAFAFA",
    },
  },
  tab: {
    "& span": {
      [theme.breakpoints.down("md")]: {
        fontSize: 12,
      },
    },
  },
  error: {
    color: theme.palette.error.main,
    [theme.breakpoints.down("md")]: {
      fontSize: 15,
      textAlign: "center",
    },
  },
  signinBtn: {
    [theme.breakpoints.down("md")]: {
      minHeight: 30,
      marginTop: 9,
    },
  },
  pwBtn: {
    [theme.breakpoints.down("md")]: {
      float: "right",
    },
    "& button": {
      [theme.breakpoints.down("md")]: {
        textTransform: "capitalize",
        fontSize: 12,
        marginTop: -2,
      },
    },
  },
  mobileLeftCol: {
    [theme.breakpoints.down("md")]: {
      width: "47%",
      borderRight: "1px solid #dddddd",
      paddingRight: "2%",
    },
  },
  mobileRightCol: {
    [theme.breakpoints.down("md")]: {
      position: "fixed",
      left: "50%",
    },
  },
});

class AdvisorInvitation extends Component {
  constructor(props) {
    super(props);

    const parsedQueryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.state = {
      invitationToken: parsedQueryString.token,
      email: null,
      password: null,
      confirm_password: null,
      streetAddress: "",
      first_name: "",
      last_name: "",
      phone: "",
      city: "",
      state: "AL",
      bdAffiliation: "",
      bdRepCode: "",
      advisorCrdRef: "",

      birthdate: moment
        .utc(this.props.user.user.birthdate)
        .format("YYYY-MM-DD"),
      captcha: null,
      message: null,
      tab: 0,
      emailAllowed: false,
    };

    this.recaptchaRef = React.createRef();
    this.debouncedFetch = debounce(this.loadBrokerDealers, 400);
  }

  handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  formatPayload = (payload) => {
    const {
      bdAffiliation,
      bdRepCode,
      message,
      tab,
      emailAllowed,
      ...newPayload
    } = payload;
    return { ...newPayload };
  };

  componentDidMount() {
    this.props.dispatch(userAction.getUserByToken(this.state.invitationToken));
  }

  componentDidUpdate(prevProps, prevState) {
    const bdRepCode =
      (this.props.user.user.repCodes &&
        this.props.user.user.repCodes.find(
          (repCode) => repCode.isSplit === true
        ) &&
        this.props.user.user.repCodes.find(
          (repCode) => repCode.isSplit === true
        ).bdRepCode) ||
      "";
    if (this.props.user !== prevProps.user) {
      this.setState({
        email: this.props.user.user.email,
        first_name: this.props.user.user.firstName,
        last_name: this.props.user.user.lastName,
        bdAffiliation: this.props.user.user.bdAffiliation,
        advisorCrdRef: this.props.user.user.advisorCrdRef,
        bdRepCode: bdRepCode,
        birthdate: moment
          .utc(this.props.user.user.birthdate)
          .format("YYYY-MM-DD"),
      });
    }

    if (
      this.props.user.user !== undefined &&
      this.props.user.user.invitationToken !==
        prevProps.user.user.invitationToken &&
      this.props.user.user.invitationToken === null
    ) {
      this.handleLoggedIn();
    }
  }

  handleSignUp = (e) => {
    e.preventDefault();
    // Since the sign-up step uses an invisible reCAPTCHA, we need to get a token from it first.
    // When we receive the reCAPTCHA token via the onChange handler on the ReCAPTCHA component, we
    // can perform the sign up.
    this.recaptchaRef.current.execute();
  };

  handleCaptchaChange = (token) => {
    this.setState({ captcha: token }, this.performSignUp);
  };

  performSignUp = () => {
    if (this.props.user.tokenAuthError !== undefined) {
      this.setState({
        message:
          "Token is no longer valid. Please contact support at info@wbicy.com",
      });
    } else if (this.state.password === this.state.confirm_password) {
      this.setState({ message: null });

      const payload = this.formatPayload(this.state);

      this.props.dispatch(userAction.createAdvisorProfile(payload));
      this.recaptchaRef.current.reset();
    } else {
      this.setState({ message: "Password does not match!" });
    }
  };
  handleLoggedIn = () => {
    const { history, location } = this.props;

    const redirectUrl =
      location.state && location.state.from ? location.state.from : "/Portal/";

    history.push(redirectUrl);
  };

  loadBrokerDealers = (inputValue, callback) => {
    this.props
      .dispatch(userAction.getBrokerDealers(inputValue))
      .then((res) => {
        const cleanedData = res.data.reduce(
          (acc, currentValue) => [
            ...acc,
            { label: currentValue.name, value: currentValue.name },
          ],
          []
        );
        callback(cleanedData);
      })
      .catch((error) => callback(error, null));
  };

  render() {
    const { classes, user } = this.props;

    return (
      <React.Fragment>
        <CenteredContent
          isSignup={this.state.tab === 1}
          headerContent={
            <Typography
              color="primary"
              style={{
                textTransform: "uppercase",
                fontSize: 12,
                textAlign: "center",
                fontWeight: "500",
                minHeight: "48px",
                alignItems: "center",
              }}
            >
              sign up
            </Typography>
          }
        >
          <form
            className={classes.form}
            onSubmit={(e) => {
              this.handleSignUp(e);
            }}
          >
            <div className={classes.mobileLeftCo}>
              <div>
                {this.props.user.tokenAuthError !== undefined && (
                  <ErrorMessage>{this.props.user.tokenAuthError}</ErrorMessage>
                )}
                {!user.loggedIn && user.message && (
                  <ErrorMessage>{user.message}</ErrorMessage>
                )}
                {this.state.message && (
                  <ErrorMessage>{this.state.message}</ErrorMessage>
                )}

                <TextField
                  disabled
                  value={this.state.email}
                  label="Email Address"
                  name="email"
                  type="email"
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Password"
                  name="password"
                  type="password"
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <React.Fragment>
                <TextField
                  label="Confirm Password"
                  name="confirm_password"
                  type="password"
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      value={this.state.first_name}
                      label="First Name"
                      name="first_name"
                      type="text"
                      onChange={this.handleChange}
                      margin="normal"
                      required
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      value={this.state.last_name}
                      label="Last Name"
                      name="last_name"
                      type="text"
                      onChange={this.handleChange}
                      margin="normal"
                      required
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
                <PhoneNumberField
                  value={this.state.phone}
                  label="Phone Number"
                  name="phone"
                  type="text"
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Phone />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Address"
                  name="streetAddress"
                  type="text"
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationCity />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="City"
                  name="city"
                  type="text"
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationCity />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="State"
                  name="state"
                  select
                  value={this.state.state}
                  onChange={this.handleChange}
                  margin="normal"
                  required
                  fullWidth
                  SelectProps={{
                    native: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationCity />
                      </InputAdornment>
                    ),
                  }}
                >
                  {Object.keys(usStates).map((stateAbbr) => (
                    <option key={stateAbbr} value={stateAbbr}>
                      {usStates[stateAbbr]}
                    </option>
                  ))}
                </TextField>
                <TextField
                  disabled
                  value={this.state.bdAffiliation}
                  fullWidth
                  margin="normal"
                  label="BD Affiliation"
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Group />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  disabled
                  value={this.state.bdRepCode}
                  label="BD Rep Code"
                  name="bdRepCode"
                  type="text"
                  margin="normal"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Group />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  disabled
                  value={this.state.advisorCrdRef}
                  label="Advisor CRD Reference"
                  name="advisorCrdRef"
                  type="number"
                  margin="normal"
                  fullWidth
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Ticket />
                      </InputAdornment>
                    ),
                  }}
                />
                <DatePicker
                  label="Date of Birth"
                  className="LoginBirthdatePicker"
                  fullWidth
                  margin="normal"
                  onChange={(date) => {
                    this.setState({
                      birthdate: moment.utc(date).format("YYYY-MM-DD"),
                      buttonDisabled: false,
                    });
                  }}
                  required
                  value={
                    this.state.birthdate
                      ? moment.utc(this.state.birthdate).format("MM/DD/YYYY")
                      : ""
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Person />
                      </InputAdornment>
                    ),
                  }}
                />
              </React.Fragment>
            </div>
            <div>
              <div className={classes.mobileRightCol}>
                <ReCAPTCHA
                  ref={this.recaptchaRef}
                  size="invisible"
                  sitekey={env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={this.handleCaptchaChange}
                />
                <div className={classes.mobileRightCol}>
                  <Button
                    disabled={this.props.user.tokenAuthError !== undefined}
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.ctaSignup}
                  >
                    Sign Up
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </CenteredContent>
      </React.Fragment>
    );
  }
}

AdvisorInvitation.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withStyles(styles)(connect(mapStateToProps)(AdvisorInvitation));



// WEBPACK FOOTER //
// ./src/containers/AdvisorInvitation/index.jsx